import imageCompression from 'browser-image-compression';

import { SOCIAL_SHARE_OG_WIDTH } from 'src/helpers/socialShareConstants';

const SKIP_TYPES = new Set(['image/svg+xml', 'image/gif']);
const SKIP_IF_UNDER_BYTES = 200 * 1024;
const OG_SKIP_IF_UNDER_BYTES = 80 * 1024;

export type ImageCompressPreset = 'default' | 'og';

export async function compressImageForUpload(
  file: File,
  preset: ImageCompressPreset = 'default',
): Promise<File> {
  if (!file.type.startsWith('image/')) {
    return file;
  }
  if (SKIP_TYPES.has(file.type)) {
    return file;
  }

  const og = preset === 'og';
  const skipUnder = og ? OG_SKIP_IF_UNDER_BYTES : SKIP_IF_UNDER_BYTES;
  if (file.size <= skipUnder) {
    return file;
  }

  try {
    return await imageCompression(file, {
      maxSizeMB: og ? 0.25 : 1.5,
      maxWidthOrHeight: og ? SOCIAL_SHARE_OG_WIDTH : 2560,
      useWebWorker: true,
      initialQuality: og ? 0.82 : 0.85,
      preserveExif: false,
      fileType: 'image/jpeg',
    });
  } catch (error) {
    console.warn('Image compression failed, uploading original file', error);
    return file;
  }
}

export async function compressImagesForUpload(
  files: File[],
  preset: ImageCompressPreset = 'default',
): Promise<File[]> {
  return Promise.all(files.map(file => compressImageForUpload(file, preset)));
}
